import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    selected: {},
    isLoaded: false,
};

const assistantSlice = createSlice({
    name: "assistant",
    initialState,
    reducers: {
        setAssistants: (state, { payload }) => {
            state.list = payload;
            state.isLoaded = true;
        },
        addAssistantToList: (state, { payload }) => {
            state.list = [...state.list, payload];
        },
        updateAssistantList: (state, { payload }) => {
            state.list = state.list.map((item) =>
                item.id === payload.id ? payload : item
            );
        },
        removeAssistantFromList: (state, { payload }) => {
            state.list = state.list.filter((item) => item.id !== payload);
        },
        setSelectedAssistant: (state, { payload }) => {
            state.selected = payload;
        },
        clearSelectedAssistant: (state) => {
            state.selected = {};
        }
    }
})

export const { setAssistants, addAssistantToList, updateAssistantList, removeAssistantFromList, setSelectedAssistant, clearSelectedAssistant } = assistantSlice.actions;
export default assistantSlice.reducer;